<template>
  <div class="mt-5 mb-5">
    <p class="text-center">
      <strong class="text-success">{{ $t("yourOrderIsRegistered", { ref: purchaseReference }) }}</strong>
    </p>
    <p class="text-center">
      <span>{{ $t('yourAccount') }}</span>
    </p>
    <p class="text-center mt-5">
      <a v-if="this.osvConfig.paths.account" :href="this.osvConfig.paths.account">
        <b-button outlined type="is-primary" native-type="button">
          {{ $t("myAccount") }}
        </b-button>
      </a>
    </p>
  </div>
</template>

<script>
import { LocaleMixin } from "@/mixins/LocaleMixin";
import { ConfigMixin } from "@/mixins/ConfigMixin";
import VueI18n from "vue-i18n";

export default {
  name: "OrderConfirmation",
  mixins: [LocaleMixin, ConfigMixin],
  props: {
    purchaseReference: String
  },

  mounted() {
    this.$i18n.locale = this.getLocale();
  },

  i18n: new VueI18n({
    locale: "fr",
    messages: {
      en: {
        yourOrderIsRegistered: "Your order %{ref} is registered.",
        yourAccount: "You can find the details of your order in your account.",
        myAccount: "My account"
      },
      fr: {
        yourOrderIsRegistered: "Votre commande %{ref} est bien enregistrée.",
        yourAccount: "Vous pouvez retrouver les détails de votre commande dans votre compte.",
        myAccount: "Mon compte"
      }
    }
  })
}
</script>
